module.exports = __webpack_public_path__ + "static/media/quotation-mark.d2ee4b23.svg";